import "vue";
const o = Symbol("LabelKey");
export {
  o as LabelKey
};
